import get from 'lodash/get'
import { connect } from 'react-redux'

import { SinglePageAmenity } from 'common/widgets/blocks'


export default connect(state => ({
  data: get(state, 'schoolNewServices.data.static_content.amenities', []),
}))(SinglePageAmenity)
